import { render } from "./chartjs-scatter.vue?vue&type=template&id=786197ea&scoped=true&ts=true"
import script from "./chartjs-scatter.vue?vue&type=script&lang=ts"
export * from "./chartjs-scatter.vue?vue&type=script&lang=ts"

import "./chartjs-scatter.vue?vue&type=style&index=0&id=786197ea&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786197ea"]])

export default __exports__